export const StepOneEntityProperty = {
  announcement_type: '',
  rent_or_sale: '',
  property_type: '',
  property_subtype: '',
  active: 'false',
  featured: 'false',
  announcement_status: '',
  listing_status: '',
  portals: [],
  private_notes: '',
}

export const StepOneEntityEnterprise = {
  announcement_type: '',
  enterprise_type: '',
  enterprise_subtype: '',
  active: 'false',
  featured: 'false',
  announcement_status: '',
  portals: [],
  private_notes: '',
}

export const validateStepOne = values => {
  const errors = {}

  if (values.announcement_type === 'property') {
    if (!values.rent_or_sale) {
      errors.rent_or_sale = 'O tipo de negociação é obrigatório'
    }

    if (!values.property_type) {
      errors.property_type = 'O tipo do imóvel é obrigatório'
    }

    if (!values.property_subtype) {
      errors.property_subtype = 'O subtipo do imóvel é obrigatório'
    }

    if (!values.listing_status) {
      errors.listing_status = 'O status do anúncio é obrigatório'
    }
  }

  if (values.announcement_type === 'enterprise') {
    if (!values.enterprise_type) {
      errors.enterprise_type = 'O tipo de empreendimento é obrigatório'
    }
  }

  if (['on_marketplace', 'on_site_marketplace'].includes(values.announcement_status)) {
    if (!values.portals || values.portals.length === 0) {
      errors.portals = 'A escolha do portal é obrigatória'
    }
  }

  if (!values.announcement_status) {
    errors.announcement_status = 'O status de exibição é obrigatório'
  }

  if (!values.featured) {
    errors.featured = 'O status de destaque é obrigatório'
  }

  if (!values.active) {
    errors.active = 'O status de ativo ou inativo é obrigatório'
  }

  return errors
}

export const stepOneOnChange = (ent, { path }) => {
  let updated = { ...ent }

  if (path === 'property_type') {
    updated.property_subtype = ''
  }

  if (path === 'enterprise_type') {
    updated.enterprise_subtype = ''
  }

  if (path === 'announcement_status') {
    updated.portals = []
  }

  return updated
}
